export default {"src":"/login-app/[GIT_HASH]/_next/static/media/source.f1f81b6c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};